import type { LogContext } from './types'

let _impl: ((error: unknown, context?: LogContext, sentryCapture?: boolean) => void) | null = null

async function loadImpl() {
    if (typeof window === 'undefined') {
        return (await import('./logHandledError.server')).logHandledError
    }
    return (await import('./logHandledError.client')).logHandledError
}

export function logHandledError(error: unknown, context: LogContext = {}, sentryCapture = false) {
    if (_impl) {
        _impl(error, context, sentryCapture)
        return
    }
    loadImpl().then((impl) => {
        _impl = impl
        _impl(error, context, sentryCapture)
    })
}
